import { Box,Button,Flex,Select,InputGroup,
  InputLeftElement,Input, Heading, Text, 
  TableContainer,Table,Thead,Tbody,Th,Tr,Td, GridItem,Image } from "@chakra-ui/react";
import { DateFilter, TopDisplay} from "../../../components";
import { LuSearch as SearchIcon } from "react-icons/lu";
import { useState ,useEffect, useMemo} from "react";
import styled from "@emotion/styled";
import { useMutation, useQuery, useQueryClient } from 'react-query';
import apiCall from '../../../utils/apiCall';
import { BsDownload as DownloadIcon } from "react-icons/bs";
import { downloadApi } from "../../../api";
import {useAtom,atom} from 'jotai'
import { openAtom, notificationAtom, openNAtom } from "../../../context";
import { Loader } from "../../../customs";
import { TbReload as ReloadIcon } from "react-icons/tb";
import ReactPaginate from 'react-paginate';
import { format } from "date-fns/format";
import {
  Grid,
  Popover,
  PopoverTrigger,
  PopoverContent,
  PopoverHeader,
  PopoverBody,
  PopoverFooter,
  PopoverArrow,
  PopoverCloseButton,
  PopoverAnchor,
} from '@chakra-ui/react'
import { modalAtom } from "../../../context";
import { MdMoreVert as MoreIcon } from "react-icons/md";



const indexAtom = atom<number | null>(null);
const list = [
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
  {
    StudentId:Math.floor(Math.random() * 10000)+1,
    FirstName:'Abey',
    LastName:'Adesola',
    OldEmail:'Abey.Adesola@gmail.com',
    NewEmail:"Osakpolo@gmail.com",
    Reason:"Not working",
    DateRequested:"01-03-2024",
    Status:"Pending",
  },
]

const HeadStyle={
  borderBottom:"1px solid var(--dark-green-color)",
  padding:'15px 5px',
}
const DataStyle = {
  padding:'5px 5px',
  thcolor:'var(--dark-green-color)'
}


const ROWSTYLE = styled.tr`
  & > td:last-of-type{
    width:50px;
    height:63px;
    & > div{
      display:none;
    }
  }
  &:hover > *{
    cursor: pointer;
    background-color:var(--table-highlight);
  } 
  & > td{
    width:140px;
  }
  &:hover > td:last-of-type{
    
    & > div{
      display: block;
    }
  }
  & > td > div.active{
    display: block;
  }
`

export default function NotRegisteredStudentReport() {
  const [hide,set_hide] = useState<boolean>(true);
const [activeIndex] = useAtom(indexAtom);
const queryClient = useQueryClient();
const [,set_open] = useAtom(openAtom);
const [,set_Nopen] = useAtom(openNAtom);
const [,set_notification]= useAtom(notificationAtom);
const [date_range,set_date_range] = useState<any>({start:'',end:''});
  const [selected_status,set_selected_status] = useState<null | string>(null);
  const [selected_level,set_selected_level] = useState<null | string>(null);
  const [selected_examperiod,set_selected_examperiod] = useState<null | string>(null);


  const {data:allLevel} = useQuery(['exemption'],{
    queryFn:async ()=> await apiCall().get(`/setup/GetAllExemption`),
    select(data){
      return data.data.Data;
    },
  })

  const {data:allExamPeriod} = useQuery(['exam-period'],{
    queryFn:async ()=> await apiCall().get(`exam/setup/examPeriod`),
    select(data){
     
      return data.data.Data;
    },
  });

  const [search, set_search] = useState('');
  const [debounced_search, set_debounced_search] = useState('');
  const itemsPerPage = 100;
  const [pageNumber, set_pageNumber] = useState(1);

  // Debounce the search box so typing doesn't fire a request per keystroke.
  useEffect(() => {
    const timer = setTimeout(() => set_debounced_search(search.trim()), 300);
    return () => clearTimeout(timer);
  }, [search]);

  useEffect(() => {
    set_pageNumber(1);
  }, [selected_level, selected_examperiod, debounced_search]);

  const selectedPeriodName = useMemo(() => {
    if (!selected_examperiod) return null;
    return (allExamPeriod || []).find((p: any) => String(p.Id) === String(selected_examperiod))?.ExamName ?? null;
  }, [allExamPeriod, selected_examperiod]);

  // One request per page, always - server applies PageNumber/PageSize plus
  // whichever filters are active. ExamPeriodId/LevelId aren't 100% reliably
  // honored by this endpoint (records only expose ExamPeriod as a name string
  // and Level as a nested { Id } object), so as a cheap (no extra request)
  // safety net we also re-check the real fields on just the page that came
  // back, instead of pre-fetching every page up front.
  const { data: pagedResult, isLoading } = useQuery(
    ['not-registered-page', selected_level, selected_examperiod, debounced_search, pageNumber],
    async () => {
      const params: Record<string, any> = {
        PageNumber: pageNumber,
        PageSize: itemsPerPage,
      };
      if (selected_level) params.LevelId = selected_level;
      if (selected_examperiod) params.ExamPeriodId = selected_examperiod;
      if (debounced_search) params.StudentNo = debounced_search;

      const response = await apiCall().get(`Exam/GetAllNotRegisteredStudent`, { params });
      return response.data;
    },
    {
      keepPreviousData: true,
      select(data: any) {
        let items = data?.reportItems || [];
        if (selected_level) items = items.filter((d: any) => String(d.Level?.Id) === String(selected_level));
        if (selectedPeriodName) items = items.filter((d: any) => d.ExamPeriod === selectedPeriodName);
        if (debounced_search) {
          const term = debounced_search.toLowerCase();
          items = items.filter((d: any) => Object.values(d).join(' ').toLowerCase().includes(term));
        }
        const totalCount = data?.TotalCount ?? items.length;
        return {
          items,
          totalCount,
          pageCount: data?.PageCount ?? Math.max(1, Math.ceil(totalCount / itemsPerPage)),
        };
      },
    }
  );

  const currentItems = pagedResult?.items || [];
  const totalCount = pagedResult?.totalCount ?? 0;
  const pageCount = pagedResult?.pageCount ?? 1;
  const itemOffset = (pageNumber - 1) * itemsPerPage;
  const endOffset = Math.min(itemOffset + itemsPerPage, totalCount);

  const handlePageClick = (event: any) => {
    set_pageNumber(event.selected + 1);
  };


  const {mutate:handleDownload,isLoading:isDownloading} = useMutation({
      mutationKey:[],
      mutationFn:async ()=> {
        const url = `/ExamReport/downloadAllNotRegisteredStudentReport?&startDate=${date_range.start || '1909-08-13'}&endDate=${date_range.end || '2100-08-13'}&ExamPeriodId=${selected_examperiod || ''}&LevelId=${selected_level || ''}`,method = "POST",body = {},config = {},download = true;
        return await downloadApi(url,method,body,config,download)
  
      },
      onSuccess:async(data:any)=>{
        //initial the download 
        console.log(data,'download data')
        let file = data;
       
        if(file){
          
          const url = window.URL.createObjectURL(file);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "NotRegistered Student-report.xlsx");
          document.body.appendChild(link);
          link.click();
          console.log(file,'data')
          set_notification({
            type:'success',
            message:data?.data?.Message || 'NotRegistered Report downloaded Successfully'
          })
          set_Nopen(true);
        }
        else{
          set_notification({
            type:'error',
            message:'Oooops! Error Occured trying to download file'
          })
          set_Nopen(true);
        }
        
      },
      onError(error:any, variables, context) {
        set_notification({
          type:'error',
          message:error?.data?.Message || 'Error Occured'
        })
        set_Nopen(true);
      },
      onSettled:()=>{
        set_open(false);
      }
  
    } )

  return (
    <>
   {isLoading?<Loader />:

    <Box>
      <TopDisplay label="Not Registered Student Report" button_array={[
        
          <Button  color="var(--white-color)" 
          bg="var(--dark-green-color)" leftIcon={<DownloadIcon/>}  
          
          onClick={()=>handleDownload()} disabled={isDownloading}
        >{isDownloading?" DownLoading....":'Download NotRegisterd Student Report'}</Button>,
         
        ]} />
        <Flex  gap="20px" wrap="wrap" mt="20px">
          <InputGroup h="40px" width="250px" bg="var(--white-color)" borderColor="var(--dark-green-color)">
            <InputLeftElement pointerEvents='none'>
              <SearchIcon color='gray.300' />
            </InputLeftElement>
            <Input value={search} onChange={(e: any) => set_search(e.target.value)} type='text' placeholder='search' />
            <span style={{position:'absolute',zIndex:'1',
            right:'10px',cursor:'pointer',top:'12px'}} onClick={() => set_search('')}><ReloadIcon /></span>
          </InputGroup>
          <Select placeholder="Level" width="140px" bg="var(--white-color)"
              borderColor="var(dark-green-color)" onChange={(e: any) => set_selected_level(e.target.value || null)} >
                {allLevel && allLevel.length > 0 ?
                    allLevel.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.Name}</option>)
                  :''}
            </Select>
            <Select placeholder='Exam Period' width="140px" bg="var(--white-color)"
            borderColor="var(dark-green-color)" onChange={(e: any) => set_selected_examperiod(e.target.value || null)}
                name="ExamPeriodId"
              >
               {allExamPeriod && allExamPeriod.length > 0 ?
                  allExamPeriod.map((eType:any) => <option key={eType.Id} value={eType.Id}>{eType.ExamName}</option>)
                :''}
              </Select>
          <DateFilter text="Date Range" onChange={set_date_range} />
        </Flex>
        <Flex mt="25px" flexDir="column" gap="10px">
          <Heading m="0" fontSize="1rem">All Not-Registered Student Report</Heading>
          <Text m="0" fontSize=".8rem">Showing {totalCount === 0 ? 0 : itemOffset + 1} - {endOffset} of {totalCount}</Text>
        </Flex>
        {  currentItems && currentItems.length > 0 ? <TableContainer mt="20px">
        <Table size='sm'>
          <Thead>
          <Tr >
                  <Th sx={HeadStyle}>StudentNo</Th>
                  <Th sx={HeadStyle}>First Name</Th>
                  <Th sx={HeadStyle}>Last Name</Th>
                  <Th sx={HeadStyle}>Email</Th>
                  {/* <Th sx={HeadStyle}>Subjects</Th> */}
                  {/* <Th sx={HeadStyle}>Study Cent.</Th> */}
                  {/* <Th sx={HeadStyle}>Last Exam</Th> */}
                  <Th sx={HeadStyle}>Level</Th>
                  <Th sx={HeadStyle}>ExamPeriod</Th>
                  {/* <Th sx={HeadStyle}>Amount</Th> */}
                  <Th sx={HeadStyle}>Phone</Th>
                  <Th sx={HeadStyle}>Reg.Date</Th>
                  <Th sx={HeadStyle} w="50px"></Th>
                </Tr>
          </Thead>
          <Tbody>
          {currentItems.map((eCandidate:any,index:number) =><ROWSTYLE key={eCandidate.SN}>
                  <Td sx={DataStyle}>{eCandidate?.StudentNo || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate?.FirstName || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate?.LastName || 'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate.Email || 'N/A'}</Td>
                  {/* <Td sx={DataStyle}>
                    {eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',')?.length > 35?eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',').slice(0,31)+' ...':eCandidate?.Subjects?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',') ||'N/A'}
                  </Td> */}
                  {/* <Td sx={DataStyle}>{eCandidate?.StudyCenter?.Name || 'N/A'}</Td> */}
                  {/* <Td sx={DataStyle}>{eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',')?.length > 35?eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',').slice(0,31)+' ...':eCandidate?.LastExam?.map((eSubject:any)=>eSubject.ExamSubject.Name)?.join(',') || 'N/A'}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.Level?eCandidate.Level.ExemptionName:'N/A'}</Td>
                  <Td sx={DataStyle}>{eCandidate.ExamPeriod || 'N/A'}</Td>
                  {/* <Td sx={DataStyle}>{eCandidate.Amount}</Td> */}
                  <Td sx={DataStyle}>{eCandidate.PhoneNumber}</Td>
                  <Td sx={DataStyle}>{format(new Date(eCandidate.RegistrationDate), "dd/MM/yyyy")}</Td>
                  <Td sx={DataStyle} minW="60px" w="50px" h="50px">
                  <div className={activeIndex === index?'active':''}>
                  <Option {...{index,candidate:eCandidate}}/>
                  </div>
                  </Td>
                </ROWSTYLE>
              )}
            </Tbody>
          </Table>
        </TableContainer>
        :'No NotRegistered Student'  
      }
      <StylePaginateBox>
        <ReactPaginate
          breakLabel="..."
          nextLabel=">"
          onPageChange={handlePageClick}
          pageRangeDisplayed={5}
          pageCount={pageCount}
          previousLabel="<"
          renderOnZeroPageCount={null}
        />

      </StylePaginateBox>

    </Box>
}
</>
  )
}
const StylePaginateBox = styled.div`
  width:100%;
  & > ul{
    list-style-type: none;
    text-align:center;
    padding:0;
    margin:0;
    margin-top:10px;
  } 
  & > ul > li{
    display: inline;
    margin:0 5px;
    padding:2px 5px;
    border-radius: 3px;
    background-color: transparent;
    color:var(--dark-green-color);
  }
  & > ul > li.selected{
    background-color: var(--highlight-paginate-background);
    color:var(--highlight-paginate-color);
  }
  & > ul > li:first-of-type,
  & > ul > li:last-of-type{
    font-weight: bold;
  }
`

const sx={
  ':hover':{
    bg:'var(--content-background)'
  }
}
const Option = (props:any)=>{
  const index = props.index;
  const candidate= props.candidate;
  const [ind,set_index] = useAtom(indexAtom);
  const [,set_open] = useAtom(openAtom);
  const [,set_modal] = useAtom(modalAtom);
  const [,set_N_open] = useAtom(openNAtom);
  const [,set_notification] = useAtom(notificationAtom);
  const [new_level,set_new_level] = useState<any>(candidate?.Level?.Id);
  const queryClient = useQueryClient();

  useEffect(()=>{
    set_new_level(candidate?.Level?.Id)
  },[])



  const onClick=()=>{
    if(index === ind){
      set_index(null);
      return;
    }
    set_index(index);
  }

  const handleShowProfile = () =>{
    set_index(null);
    set_modal({
      header:'Candidate Details',
      content:<ViewProfile candidate={candidate} />
    })
    set_open(true);
  }
  useEffect(()=>{
    return ()=>set_index(null)
  },[])
  return(
    <Popover>
    <PopoverTrigger>
      <Button onClick={onClick} bg="var(--cipm-light-green)"><MoreIcon /></Button>
    </PopoverTrigger>
    <PopoverContent width="fit-content">
      <PopoverArrow />
      <PopoverBody>
        <Grid templateColumns="1fr" p="6px">
          <GridItem sx={sx} p="8px 4px" onClick={handleShowProfile}>View Details</GridItem>
        </Grid>
      </PopoverBody>
    </PopoverContent>
  </Popover>
  )
}
const ViewProfile = (props:any) =>{
  const img = "/public-assets/profile.png";
  return(
  <Flex flexDir="column" minWidth="600px" maxWidth="60dvw" gap="50px">
    <Flex align="center" gap="20px">
      <Flex flexDir="column">
        <Heading fontSize="1rem">{props.candidate.FirstName+" "+props.candidate.LastName}</Heading>
        <Text>Student</Text>
        <Text>ID: {props.candidate.Subjects.at(0).StudentNo}</Text>
      </Flex>
    </Flex>
    <Grid templateColumns="repeat(3,1fr)"  gap="30px">
      
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Level</Text>
        <Text fontWeight="500">{props.candidate?.Level?.ExemptionName}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">ExamPeriod</Text>
        <Text fontWeight="500">{props.candidate.ExamPeriod || 'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Study Center</Text>
        <Text fontWeight="500">{props.candidate.StudyCenter || 'N/A'}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)"> Registration Date</Text>
        <Text fontWeight="500">{format(new Date(props.candidate.RegistrationDate), "dd/MM/yyyy")}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Email Address</Text>
        <Text fontWeight="500">{props.candidate.Email}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Phone No.</Text>
        <Text fontWeight="500">{props.candidate.PhoneNumber}</Text>
      </GridItem>
      <GridItem>
        <Text fontWeight="500" color="var(--light-text)">Address</Text>
        <Text fontWeight="500">{props.candidate.Address}</Text>
      </GridItem>
    </Grid>
  </Flex>
  )}
